import { render, staticRenderFns } from "./requirementList.vue?vue&type=template&id=380ebc81&scoped=true"
import script from "./requirementList.vue?vue&type=script&lang=js"
export * from "./requirementList.vue?vue&type=script&lang=js"
import style0 from "./requirementList.vue?vue&type=style&index=0&id=380ebc81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ebc81",
  null
  
)

export default component.exports